import * as Yup from "yup";

import {
  MessagingStrategyName,
  PhoneNumberMessageClass,
  ProviderName,
} from "~frontend/__generated__/graphql";

import OwnedPhoneNumberPicker from "./common/OwnedPhoneNumberPicker";
import { MessagingStrategyConfigComponent, OwnedPhoneNumber } from "./types";

function filterPhoneNumbers(
  phoneNumbers: OwnedPhoneNumber[]
): OwnedPhoneNumber[] {
  return phoneNumbers.filter(
    phoneNumber =>
      phoneNumber.provider === ProviderName.Bandwidth &&
      phoneNumber.messageClass === PhoneNumberMessageClass.TollFree &&
      !phoneNumber.optInGroup
  );
}

const BandwidthTollFreeMessagingStrategyConfig: MessagingStrategyConfigComponent<MessagingStrategyName.BandwidthTollFree> =
  {
    Component: props => (
      <OwnedPhoneNumberPicker
        readOnly={props.readOnly}
        name="messagingStrategy.config.ownedPhoneNumberId"
        ownedPhoneNumbers={
          props.readOnly
            ? [props.savedConfig.ownedPhoneNumber]
            : filterPhoneNumbers(props.ownedPhoneNumbers)
        }
      />
    ),
    configValidationSchema: Yup.object().shape({
      ownedPhoneNumberId: Yup.string().required("Required"),
    }),
    formValuesToConfigInput: vals => vals,
    campaignConfigToFormValues: config => ({
      ownedPhoneNumberId: config.ownedPhoneNumber.id,
    }),
    defaultFormValues: ({ ownedPhoneNumbers }) => ({
      ownedPhoneNumberId: filterPhoneNumbers(ownedPhoneNumbers)[0]!.id,
    }),
  };

export default BandwidthTollFreeMessagingStrategyConfig;
